import useAsync from 'Hooks/useAsync';
import { getCategoriesApi } from '../API/tableAPI/groupAPI';

interface CategoryFilter {
  label: string;
  ids: number[];
}

const useCategoryGroups = () => {
  return useAsync<CategoryFilter[]>(
    async () => {
      const groups = await getCategoriesApi();

      const aa = groups.filter((x) => x.isTopLevel).map((x) => x.id);
      const topLevelGroups = groups.filter((x) => !x.parentId);
      const zz = topLevelGroups.map((topGroup) => ({
        label: topGroup.name ?? '',
        ids: groups
          .filter(
            (subGroup) =>
              (subGroup.parentId as unknown) === (topGroup.id as unknown),
          )
          .map((subGroup) => subGroup.id),
      }));

      return [
        { label: 'trending', ids: aa },
        ...zz,
        { label: 'all', ids: groups.filter((g) => g.isLeaf).map((g) => g.id) },
      ];
    },
    { deps: [] },
  );
};

export default useCategoryGroups;
